import {
  FETCH_ORDER_TRIGGERS_START,
  FETCH_ORDER_TRIGGERS_SUCCESS,
  FETCH_ORDER_TRIGGERS_FAIL,
} from './action';

const initialState = {
  items: [],
  isLoading: false,
  err: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
  case FETCH_ORDER_TRIGGERS_START:
    return { ...state, isLoading: true, err: null };
  case FETCH_ORDER_TRIGGERS_SUCCESS:
    return { items: action.payload || [], isLoading: false, err: null };
  case FETCH_ORDER_TRIGGERS_FAIL:
    return { ...state, isLoading: false, err: action.payload };
  default:
    return state;
  }
};
